module.exports = {
	LimitedPartnerV1: 'LimitedPartnerV1',
	LimitedPartnerV2: 'LimitedPartnerV2',
	LimitedPartnerV3: 'LimitedPartnerV3',
	LimitedPartnerV4: 'LimitedPartnerV4',
	LimitedPartnerV5: 'LimitedPartnerV5',
	LimitedPartnerV6: 'LimitedPartnerV6',
	LimitedPartnerV7: 'LimitedPartnerV7',
	LimitedPartnerV8: 'LimitedPartnerV8',
	LimitedPartnerV8_1: 'LimitedPartnerV8_1',

	// Versioning by new fund created
	LimitedPartnerV9: 'LimitedPartnerV9',
	LimitedPartnerV10: 'LimitedPartnerV10',
	LimitedPartnerV10_1: 'LimitedPartnerV10_1',
	LimitedPartnerV11: 'LimitedPartnerV11',
	LimitedPartnerV12: 'LimitedPartnerV12',
	LimitedPartnerV13: 'LimitedPartnerV13',
	LimitedPartnerV14: 'LimitedPartnerV14',
	LimitedPartnerV15: 'LimitedPartnerV15',

	LimitedPartnerV14_Seifdune: 'LimitedPartnerV14_Seifdune',
	LimitedPartnerV14_Nosara: 'LimitedPartnerV14_Nosara',
	LimitedPartnerV14_Drumbeat: 'LimitedPartnerV14_Drumbeat',
	LimitedPartnerV14_teamworthy: 'LimitedPartnerV14_teamworthy',

	LimitedLiabilityCompanyV1: 'LimitedLiabilityCompanyV1',
	LimitedLiabilityCompanyV2: 'LimitedLiabilityCompanyV2',
	LimitedLiabilityCompanyV3: 'LimitedLiabilityCompanyV3',
	LimitedLiabilityCompanyV4: 'LimitedLiabilityCompanyV4',
	LimitedLiabilityCompanyV5: 'LimitedLiabilityCompanyV5',
	LimitedLiabilityCompanyV6: 'LimitedLiabilityCompanyV6',
	LimitedLiabilityCompanyV6_1: 'LimitedLiabilityCompanyV6_1',

	// Versioning by new fund created
	LimitedLiabilityCompanyV7: 'LimitedLiabilityCompanyV7',
	LimitedLiabilityCompanyV8: 'LimitedLiabilityCompanyV8',
	LimitedLiabilityCompanyV8_1: 'LimitedLiabilityCompanyV8_1',
	LimitedLiabilityCompanyV9: 'LimitedLiabilityCompanyV9',
	LimitedLiabilityCompanyV10: 'LimitedLiabilityCompanyV10',
	LimitedLiabilityCompanyV11: 'LimitedLiabilityCompanyV11',
	LimitedLiabilityCompanyV12: 'LimitedLiabilityCompanyV12',
	LimitedLiabilityCompanyV13: 'LimitedLiabilityCompanyV13',
	LimitedLiabilityCompanyV11_ecp: 'LimitedLiabilityCompanyV11_ecp',

	ForesiteV1: 'ForesiteV1',
	ForesiteV2: 'ForesiteV2',
	ForesiteV3: 'ForesiteV3',
	ForesiteV4: 'ForesiteV4',
	ForesiteV5: 'ForesiteV5',
	ForesiteV6: 'ForesiteV6',
	ForesiteV7: 'ForesiteV7',
	ForesiteV8: 'ForesiteV8',
	ForesiteV9: 'ForesiteV9',
	ForesiteV10: 'ForesiteV10',

	QuestaCapitalV1: 'QuestaCapitalV1',
	QuestaCapitalV2: 'QuestaCapitalV2',
	QuestaCapitalV3: 'QuestaCapitalV3',
	QuestaCapitalV4: 'QuestaCapitalV4',
	QuestaCapitalV5: 'QuestaCapitalV5',
	QuestaCapitalV6: 'QuestaCapitalV6',
	QuestaCapitalV7: 'QuestaCapitalV7',
	QuestaCapitalV8: 'QuestaCapitalV8',
	QuestaCapitalV9: 'QuestaCapitalV9',
	QuestaCapitalV10: 'QuestaCapitalV10',

	InitializedV1: 'InitializedV1',
	InitializedV2: 'InitializedV2',
	InitializedV3: 'InitializedV3',
	InitializedV4: 'InitializedV4',
	InitializedV5: 'InitializedV5',
	InitializedV6: 'InitializedV6',
	InitializedV7: 'InitializedV7',
	InitializedV8: 'InitializedV8',
	InitializedV9: 'InitializedV9',
	InitializedV10: 'InitializedV10',

	HCMV1: 'HCMV1',
	HCMV2: 'HCMV2',
	HCMV3: 'HCMV3',
	HCMV4: 'HCMV4',
	HCMV5: 'HCMV5',
	HCMV6: 'HCMV6',
	HCMV7: 'HCMV7',

	ForesiteLabsV1: 'ForesiteLabsV1',
	ForesiteLabsV2: 'ForesiteLabsV2',
	ForesiteLabsV3: 'ForesiteLabsV3',
	ForesiteLabsV4: 'ForesiteLabsV4',
	ForesiteLabsV5: 'ForesiteLabsV5',
	ForesiteLabsV6: 'ForesiteLabsV6',
	ForesiteLabsV7: 'ForesiteLabsV7',
	ForesiteLabsV8: 'ForesiteLabsV8',

	LPABBRV1: 'LPABBRV1',
	LPABBRV1_1: 'LPABBRV1_1',

	// Versioning by new fund created
	LPABBRV2: 'LPABBRV2',
	LPABBRV3: 'LPABBRV3',
	LPABBRV3_1: 'LPABBRV3_1',
	LPABBRV4: 'LPABBRV4',
	LPABBRV5: 'LPABBRV5',
	LPABBRV6: 'LPABBRV6',
	LPABBRV7: 'LPABBRV7',
	LPABBRV8: 'LPABBRV8',

	IOLARV1: 'IOLVARV1',
	IOLARV2: 'IOLVARV2',
	IOLARV3: 'IOLVARV3',
	IOLARV4: 'IOLVARV4',
	IOLARV5: 'IOLVARV5',

	OSAGEV1: 'OSAGEV1',
	OSAGEV2: 'OSAGEV2',
	OSAGEV3: 'OSAGEV3',
	OSAGEV4: 'OSAGEV4',
	OSAGEV5: 'OSAGEV5',

	NewLimitedPartnerV1: 'NewLimitedPartnerV1',
	NewLimitedPartnerV2: 'NewLimitedPartnerV2',
	NewLimitedPartnerV3: 'NewLimitedPartnerV3',
	NewLimitedPartnerV4: 'NewLimitedPartnerV4',
	NewLimitedPartnerV5: 'NewLimitedPartnerV5',

	TcgCrossOverV1: 'TcgCrossOverV1',
	TcgCrossOverV2: 'TcgCrossOverV2',
	TcgCrossOverV3: 'TcgCrossOverV3',
	TcgCrossOverV4: 'TcgCrossOverV4',
	TcgCrossOverV5: 'TcgCrossOverV5',

	TcgCrossOverCaymanV1: 'TcgCrossOverCaymanV1',
	TcgCrossOverCaymanV2: 'TcgCrossOverCaymanV2',

	BITKRAFTV1: 'BITKRAFTV1',
	BITKRAFTV2: 'BITKRAFTV2',
	BITKRAFTV3: 'BITKRAFTV3',
	BITKRAFTV4: 'BITKRAFTV4',
	BITKRAFTV5: 'BITKRAFTV5',

	BitkraftIndiaV1: 'BitkraftIndiaV1',
	BitkraftIndiaV2: 'BitkraftIndiaV2',
	BitkraftIndiaV3: 'BitkraftIndiaV3',

	ElephantPartnerV1: 'ElephantPartnerV1',
	ElephantPartnerV2: 'ElephantPartnerV2',
	ElephantPartnerV3: 'ElephantPartnerV3',
	ElephantPartnerV4: 'ElephantPartnerV4',
	ElephantPartnerV5: 'ElephantPartnerV5',

	FireworkV1: 'FireworkV1',
	FireworkV2: 'FireworkV2',
	FireworkV3: 'FireworkV3',
	FireworkV4: 'FireworkV4',
	FireworkV5: 'FireworkV5',

	PrometheanV1: 'PrometheanV1',
	PrometheanV2: 'PrometheanV2',
	PrometheanV3: 'PrometheanV3',
	PrometheanV4: 'PrometheanV4',
	PrometheanV5: 'PrometheanV5',

	AccelV1: 'AccelV1',
	AccelV2: 'AccelV2',
	AccelV3: 'AccelV3',
	AccelV4: 'AccelV4',

	AccelMainV1: 'AccelMainV1',
	AccelMainV2: 'AccelMainV2',
	AccelMainV3: 'AccelMainV3',

	AccelEntrepreneursV1: 'AccelEntrepreneursV1',
	AccelEntrepreneursV2: 'AccelEntrepreneursV2',

	AccelCircleV1: 'AccelCircleV1',
	AccelCircleV2: 'AccelCircleV2',

	AccelEtpnReturningV1: 'AccelEtpnReturningV1',
	AccelEtpnReturningV2: 'AccelEtpnReturningV2',

	AccelEtpnReturningMultiV1: 'AccelEtpnReturningMultiV1',
	AccelEtpnReturningMultiV2: 'AccelEtpnReturningMultiV2',

	//Short MultiFund
	LPMULTIFUNDV1: 'LPMULTIFUNDV1',

	// Versioning by new fund created
	LPMULTIFUNDV2: 'LPMULTIFUNDV2',
	LPMULTIFUNDV2_1: 'LPMULTIFUNDV2_1',
	LPMULTIFUNDV3: 'LPMULTIFUNDV3',
	LPMULTIFUNDV4: 'LPMULTIFUNDV4',
	LPMULTIFUNDV5: 'LPMULTIFUNDV5',
	LPMULTIFUNDV6: 'LPMULTIFUNDV6',
	LPMULTIFUNDV7: 'LPMULTIFUNDV7',

	LimitedPartnershipMFV1: 'LimitedPartnershipMFV1',
	LimitedPartnershipMFV2: 'LimitedPartnershipMFV2',
	LimitedPartnershipMFV2_1: 'LimitedPartnershipMFV2_1',
	LimitedPartnershipMFV3: 'LimitedPartnershipMFV3',
	LimitedPartnershipMFV4: 'LimitedPartnershipMFV4',
	LimitedPartnershipMFV5: 'LimitedPartnershipMFV5',
	LimitedPartnershipMFV6: 'LimitedPartnershipMFV6',
	LimitedPartnershipMFV7: 'LimitedPartnershipMFV7',
	LimitedPartnershipMFV6_SparkCapital: 'LimitedPartnershipMFV6_SparkCapital',

	PictureCapitalV1: 'PictureCapitalV1',
	PictureCapitalV2: 'PictureCapitalV2',
	PictureCapitalV3: 'PictureCapitalV3',

	SinglePictureCapitalV1: 'SinglePictureCapitalV1',
	SinglePictureCapitalV2: 'SinglePictureCapitalV2',

	AudereV1: 'AudereV1',
	AudereV2: 'AudereV2',
	AudereV3: 'AudereV3',
	AudereV4: 'AudereV4',
	AudereV5: 'AudereV5',

	CaymanV1: 'CaymanV1',
	CaymanV2: 'CaymanV2',
	CaymanV3: 'CaymanV3',
	CaymanV4: 'CaymanV4',
	CaymanV5: 'CaymanV5',
	CaymanV6: 'CaymanV6',
	CaymanV7: 'CaymanV7',

	SROneV1: 'SROneV1',
	SROneV2: 'SROneV2',
	SROneV3: 'SROneV3',
	SROneV4: 'SROneV4',

	FrazierV1: 'FrazierV1',
	FrazierV2: 'FrazierV2',
	FrazierV3: 'FrazierV3',
	FrazierV4: 'FrazierV4',

	TerrariumV1: 'TerrariumV1',
	TerrariumV2: 'TerrariumV2',
	TerrariumV3: 'TerrariumV3',

	DCVCV1: 'DCVCV1',
	DCVCV2: 'DCVCV2',
	DCVCV3: 'DCVCV3',
	DCVCV4: 'DCVCV4',

	OCMV1: 'OCMV1',
	OCMV2: 'OCMV2',
	OCMV3: 'OCMV3',

	NICFUNDV1: 'NICFUNDV1',
	NICFUNDV2: 'NICFUNDV2',
	NICFUNDV3: 'NICFUNDV3',

	VariantV1: 'VariantV1',
	VariantV2: 'VariantV2',
	VariantV3: 'VariantV3',

	SorensonV1: 'SorensonV1',
	SorensonV2: 'SorensonV2',
	SorensonV3: 'SorensonV3',

	UnionPeakV1: 'UnionPeakV1',
	UnionPeakV2: 'UnionPeakV2',
	UnionPeakV3: 'UnionPeakV3',

	AltimeterV1: 'AltimeterV1',
	AltimeterV2: 'AltimeterV2',

	AltimeterAMLV1: 'AltimeterAMLV1',

	AltimeterPremierGrowthV1: 'AltimeterPremierGrowthV1',

	BenchmarkV1: 'BenchmarkV1',
	BenchmarkV2: 'BenchmarkV2',
	BenchmarkV3: 'BenchmarkV3',

	BenchmarkMultiFundV1: 'BenchmarkMultiFundV1',
	BenchmarkMultiFundV2: 'BenchmarkMultiFundV2',
	BenchmarkMultiFundV3: 'BenchmarkMultiFundV3',
};
